import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
import { borderColor, borderRadius, boxSizing, display, fontSize, fontWeight, textAlign } from '@mui/system';
import { m } from 'framer-motion';
import { thirdly2 } from 'styles/theme';
import { gray } from 'styles/theme';
import { sidebar } from 'styles/theme';
import { bg } from 'styles/theme';
import { thirdly } from 'styles/theme';
import { thirdly4 } from 'styles/theme';

export const CreateAssessmentDefStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    '.draft-box': {
        width: "400px !important"
    },
    '.wrap-content': {
        display: "flex",
        columnGap: 10,
        height: `calc(100% - 212px)`
    },
    '.num-page': {
        fontSize: "20px !important"
    },
    '.selected-page': {
        background: "white !important",
        border: `1px solid ${thirdly}`,
    },
    '.content': {
        height: "100%",
        justifyContent: "center",
        overflow: "auto",
        boxSizing: "border-box",
        width: "100%",
        background: "white",
        borderRadius: 20,
        flexGrow: 1,
        padding: 20,
        display: "flex",
        marginBottom: footerHeight + 20
    },
    '.page': {
        ':hover': {
            opacity: 0.7
        },
        cursor: "pointer",
        width: 85,
        height: 80,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 15,
        background: thirdly4
    },
    '.select-font-size': {
        width: 280
    },
    '.pages': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.wrap-pages': {
        display: "flex",
        height: 150
    },
    '.question-section': {
        overflow: "auto",
        boxSizing: "border-box",
        padding: 15,
        background: thirdly4,
        borderRadius: 10,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        rowGap: 20
    },
    '.view-assessment-def': {
        width: 350,
        flexGrow: "initial",
        height: `calc(100% - ${footerHeight - 10}px)`
    },
    '.assessment-def-content': {
        display: "flex",
        flexGrow: 1,
        columnGap: 50,
        form: {
            flexGrow: 1
        }
    },
    '.continue-button': {
        display: "flex",
        justifyContent: "end"
    },
    '.section3-fields': {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    },
    '.sections': {
        display: "flex",
        columnGap: 50
    },
    '.wrap-form': {
        height: "100%",
        display: "flex",
        alignItems: "center",
        padding: "0px 30px"
    },
    '.fields2': {
        display: "flex !important",
        flexDirection: "row !important",
        columnGap: 10
    },
    '.section': {
        width: 500,
        display: "flex",
        flexDirection: "column",
        rowGap: 25
    },
    '.fields': {
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.section-title': {
        fontWeight: "bold"
    }
}));

export const DraftTextStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    width: "100%",
    height: "100%",
    background: "white",
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.upload-file': {
        width: 195
    },
    '.upload-actions': {
        display: "flex",
        alignItems: "center",
        columnGap: 10,
        width: "100%"
    },
    'textarea': {
        overflow: "auto !important",
        fontSize: 23,
        height: "100% !important",
        width: "100%",
        border: `2px solid ${thirdly2}`,
        borderRadius: 10,
        direction: "ltr",
        padding: "10px",
        boxSizing: "border-box",
        fontFamily: [
            "Calibri", "sans-serif"
        ].join(',')
    }
}));


export const ActionButtonsStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "end",
    columnGap: 10,
    height: "100%",
    alignItems: "center",
    width: 290
}));

const footerHeight = 90

export const StepFooterStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: footerHeight,
    display: "flex",
    justifyContent: "space-between",
    columnGap: 10,
    background: "white",
    width: `calc(100% - ${sidebar}px)`,
    marginLeft: sidebar,
    position: "absolute",
    bottom: 0,
    right: 0,
    padding: 20,
    boxSizing: "border-box",
    '.steps': {
        flexGrow: 1,
        display: "flex",
        columnGap: 50,
        marginLeft: 20
    },
    '.step': {
        ":hover": {
            opacity: 0.8
        },
        cursor: "pointer",
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        borderRadius: 8,
        padding: 7
    },
    '.MuiLinearProgress-root': {
        width: 300,
        height: 9,
        borderRadius: 15
    },
    '.selected-step': {
        background: bg,
    }
}));

export const MultipleChoiseStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    '.page-content': {
        flexGrow: 1,
        width: 400,
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
        borderRadius: 8
    },
    '.book-page': {
        display: "flex",
        columnGap: 3,
        borderRadius: 15
    },
    '.placeholder-lines-icon': {
        position: "absolute",
        bottom: -24,
        left: -10,
        '.MuiSvgIcon-root': {
            fontSize: 40
        }
    },
    '.placeholder-lines': {
        transform: "translateZ(0px)",
        flexShrink: 0,
    },
    '.answer-input': {
        flexGrow: 1
    },
    '.num-answer': {
        fontWeight: "bold"
    },
    '.wrap-answer': {
        width: "80%",
        display: "flex",
        columnGap: 8,
        marginTop: 5,
        alignItems: "center"
    },
    '.wrap-answers': {
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.sub-title': {
        color: "#00000080",
        fontWeight: 400
    },
    '.title': {
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between"
    },
    '.create-assessment-title': {
        fontWeight: "bold"
    },
    '.single-book-page-right': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
    },
    '.single-book-page-left': {
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0
    },
}));

export const BookStyles = muiStyled(Box)(({ fontSize, theme, $systemUI }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    '.cover-text': {
        display: "flex",
        flexDirection: "row",
        alignItems: "start",
        justifyContent: "start !important",
        height: "auto !important",
        width: "270px !important",
        marginLeft: 10
    },
    '.book-content-field': {
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textarea: {
            fontSize: fontSize?.id || 40,
            textAlign: "start",
            fontWeight: "bold"
        }
    },
    '.page-text': {
        width: "100%",
        flexGrow: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    '.wrap-number-page': {
        width: "100%",
        display: "flex",
        boxSizing: "border-box",
        height: 60
    },
    '.right-page': {
        justifyContent: "end"
    },
    '.number-page': {
        color: gray,
        borderRadius: 40,
        width: 30,
        height: 30,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 5,
        fontSize: 22,
        border: `1px solid ${gray}`
    },
    '.page-content': {
        boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
        borderRadius: 8,
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        padding: "15px 25px 35px 15px"
    },
    '.book-page': {
        display: "flex",
        columnGap: 3,
        borderRadius: 15
    },
    '.placeholder-lines-icon': {
        position: "absolute",
        bottom: -24,
        left: -10,
        '.MuiSvgIcon-root': {
            fontSize: 40
        }
    },
    '.placeholder-lines': {
        transform: "translateZ(0px)",
        flexShrink: 0,
    },
    '.sub-title': {
        color: "#00000080",
        fontWeight: 400
    },
    '.title': {
        fontWeight: "bold",
        display: "flex",
        justifyContent: "space-between"
    },
    '.create-assessment-title': {
        fontWeight: "bold"
    },
    '.wrap-pages': {
        display: "flex",
        height: 150,
        justifyContent: "space-between",
        alignItems: "center"
    },
    '.single-book-page-right': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
    },
    '.single-book-page-left': {
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0
    },
    '.cover': {
        width: "50% !important",
        flexGrow: "initial !important",
        backgroundImage: `url(https://i.ibb.co/xSRRqTpK/Mask-Start.png)`,
        backgroundSize: "cover"
    },
    '.cover-book': {
        borderRadius: 15
    },
}));

export const WordsStyles = muiStyled(Box)(({ columnGap, columnCount, cardWidth, fontSize, theme, $systemUI }) => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    '.wrap-pages': {
        justifyContent: "space-between",
        alignItems: "center"
    },
    '.word-field': {
        'input': {
            textAlign: "center",
            fontSize: fontSize || 40
        }
    },
    '.word': {
        marginBottom: columnGap || 30,
        width: cardWidth + 15,
        height: 100,
        borderRadius: 10,
        border: `2px solid ${thirdly2}`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: fontSize?.id || 40,
    },
    '.words': {
        columnCount: columnCount || 3,
        columnGap: columnGap || 30
    },
    '.content': {
        alignItems: "center"
    }
}));